import React, { useMemo, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { vesselServices } from "../services/vessels.services";
import { useDispatch, useSelector } from "react-redux";
import { alertActions } from "../../_actions";
import { alertConstants } from "../../_constants";
import classes from "../assets/css/vessels.module.css";
import { decrypt, encrypt } from "../../_helpers";
import { encodeBase64 } from "tweetnacl-util";
import nacl from "tweetnacl";

export default function TransferVessel({
  vesselId,
  toggle,
  show,
  sheetName,
  userId,
  setVessels,
  publicKey,
  secretKey,
}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [vessel, setVessel] = useState({});
    const user = useSelector((state) => state.authentication.user);
  
  useMemo(async () => {
    if (vesselId !== null) {
      const response = await vesselServices.getVesselById(vesselId);

      const vessel = {
        sheetName: decrypt(response?.vessel?.sheetName, publicKey, secretKey),
        vesselName: decrypt(response?.vessel?.vesselName, publicKey, secretKey),
        vesselIMO: decrypt(response?.vessel?.vesselIMO, publicKey, secretKey),
        vesselRegistryPort: decrypt(
          response?.vessel?.vesselRegistryPort,
          publicKey,
          secretKey
        ),
        vesselFlag: decrypt(response?.vessel?.vesselFlag, publicKey, secretKey),
        vesselType: decrypt(response?.vessel?.vesselType, publicKey, secretKey),
        vesselLOA: decrypt(
          `${response?.vessel?.vesselLOA}`,
          publicKey,
          secretKey
        ),
        vesselMaxPassengersWithStaterooms: decrypt(
          `${response?.vessel?.vesselMaxPassengersWithStaterooms}`,
          publicKey,
          secretKey
        ),
        vesselDayPassengersOnBoard: decrypt(
          `${response?.vessel?.vesselDayPassengersOnBoard}`,
          publicKey,
          secretKey
        ),
        vesselServiceProvider: decrypt(
          response?.vessel?.vesselServiceProvider,
          publicKey,
          secretKey
        ),
        vesselServiceProviderAddress: decrypt(
          response?.vessel?.vesselServiceProviderAddress,
          publicKey,
          secretKey
        ),
        vesselServiceProviderCompany: decrypt(
          `${response?.vessel?.vesselServiceProviderCompany}`,
          publicKey,
          secretKey
        ),
        vesselServiceProviderInsuranceRef: decrypt(
          response?.vessel?.vesselServiceProviderInsuranceRef,
          publicKey,
          secretKey
        ),
        vesselServiceProviderVAT: decrypt(
          response?.vessel?.vesselServiceProviderVAT,
          publicKey,
          secretKey
        ),
        vesselCentralAgent: decrypt(
          response?.vessel?.vesselCentralAgent,
          publicKey,
          secretKey
        ),
        vesselCentralAgentAddress: decrypt(
          response?.vessel?.vesselCentralAgentAddress,
          publicKey,
          secretKey
        ),
        vesselCentralAgentCompany: decrypt(
          `${response?.vessel?.vesselCentralAgentCompany}`,
          publicKey,
          secretKey
        ),
        vesselCentralAgentInsuranceRef: decrypt(
          response?.vessel?.vesselCentralAgentInsuranceRef,
          publicKey,
          secretKey
        ),
        vesselCentralAgentVAT: decrypt(
          response?.vessel?.vesselCentralAgentVAT,
          publicKey,
          secretKey
        ),
        vesselCentralAgentMYBA: decrypt(
          response?.vessel?.vesselCentralAgentMYBA,
          publicKey,
          secretKey
        ),
        vesselStakeholder: decrypt(
          response?.vessel?.vesselStakeholder,
          publicKey,
          secretKey
        ),
        vesselStakeholderAddress: decrypt(
          response?.vessel?.vesselStakeholderAddress,
          publicKey,
          secretKey
        ),
        vesselStakeholderCompany: decrypt(
          `${response?.vessel?.vesselStakeholderCompany}`,
          publicKey,
          secretKey
        ),
        vesselStakeholderInsuranceRef: decrypt(
          response?.vessel?.vesselStakeholderInsuranceRef,
          publicKey,
          secretKey
        ),
        vesselStakeholderMYBA: decrypt(
          response?.vessel?.vesselStakeholderMYBA,
          publicKey,
          secretKey
        ),
        vesselStakeholderVAT: decrypt(
          response?.vessel?.vesselStakeholderVAT,
          publicKey,
          secretKey
        ),
        vesselStakeholderFinancialGuarantee: decrypt(
          response?.vessel?.vesselStakeholderFinancialGuarantee,
          publicKey,
          secretKey
        ),
        vesselSpecialConditions: decrypt(
          response?.vessel?.vesselSpecialConditions,
          publicKey,
          secretKey
        ),
      };
      setVessel(vessel);
    }
  }, [vesselId]);

  const handleChange = (e) => {
    setEmail(e.target.value);
  };
  const handleTransfer = async () => {
    try {
       if (email === user?.email) {
              dispatch(
                alertActions.setAlert(
                  t("You cannot transfer a vessel to yourself"),
                  alertConstants.ERROR,
                ),
              );
            }else{
                setIsLoading(true);
      const keyPair = nacl.box.keyPair();

      const vesselPublicKey = encodeBase64(keyPair.publicKey);
      const vesselSecretKey = encodeBase64(keyPair.secretKey);

      const keys = { vesselPublicKey, vesselSecretKey };
      const cryptedData = {
        decryptedSheetName: vessel?.sheetName,
        sheetName: encrypt(vessel?.sheetName, vesselPublicKey, vesselSecretKey),
        vesselName: encrypt(
          vessel?.vesselName,
          vesselPublicKey,
          vesselSecretKey
        ),
        vesselIMO: encrypt(vessel?.vesselIMO, vesselPublicKey, vesselSecretKey),
        vesselRegistryPort: encrypt(
          vessel?.vesselRegistryPort,
          vesselPublicKey,
          vesselSecretKey
        ),
        vesselFlag: encrypt(
          vessel?.vesselFlag,
          vesselPublicKey,
          vesselSecretKey
        ),
        vesselType: encrypt(
          vessel?.vesselType,
          vesselPublicKey,
          vesselSecretKey
        ),
        vesselLOA: encrypt(
          `${vessel?.vesselLOA}`,
          vesselPublicKey,
          vesselSecretKey
        ),
        vesselMaxPassengersWithStaterooms: encrypt(
          `${vessel?.vesselMaxPassengersWithStaterooms}`,
          vesselPublicKey,
          vesselSecretKey
        ),
        vesselDayPassengersOnBoard: encrypt(
          `${vessel?.vesselDayPassengersOnBoard}`,
          vesselPublicKey,
          vesselSecretKey
        ),
        vesselServiceProvider: encrypt(
          vessel?.vesselServiceProvider,
          vesselPublicKey,
          vesselSecretKey
        ),
        vesselServiceProviderAddress: encrypt(
          vessel?.vesselServiceProviderAddress,
          vesselPublicKey,
          vesselSecretKey
        ),
        vesselServiceProviderCompany: encrypt(
          `${vessel?.vesselServiceProviderCompany}`,
          vesselPublicKey,
          vesselSecretKey
        ),
        vesselServiceProviderInsuranceRef: encrypt(
          vessel?.vesselServiceProviderInsuranceRef,
          vesselPublicKey,
          vesselSecretKey
        ),
        vesselServiceProviderVAT: encrypt(
          vessel?.vesselServiceProviderVAT,
          vesselPublicKey,
          vesselSecretKey
        ),
        vesselCentralAgent: encrypt(
          vessel?.vesselCentralAgent,
          vesselPublicKey,
          vesselSecretKey
        ),
        vesselCentralAgentAddress: encrypt(
          vessel?.vesselCentralAgentAddress,
          vesselPublicKey,
          vesselSecretKey
        ),
        vesselCentralAgentCompany: encrypt(
          `${vessel?.vesselCentralAgentCompany}`,
          vesselPublicKey,
          vesselSecretKey
        ),
        vesselCentralAgentInsuranceRef: encrypt(
          vessel?.vesselCentralAgentInsuranceRef,
          vesselPublicKey,
          vesselSecretKey
        ),
        vesselCentralAgentVAT: encrypt(
          vessel?.vesselCentralAgentVAT,
          vesselPublicKey,
          vesselSecretKey
        ),
        vesselCentralAgentMYBA: encrypt(
          vessel?.vesselCentralAgentMYBA,
          vesselPublicKey,
          vesselSecretKey
        ),
        vesselStakeholder: encrypt(
          vessel?.vesselStakeholder,
          vesselPublicKey,
          vesselSecretKey
        ),
        vesselStakeholderAddress: encrypt(
          vessel?.vesselStakeholderAddress,
          vesselPublicKey,
          vesselSecretKey
        ),
        vesselStakeholderCompany: encrypt(
          `${vessel?.vesselStakeholderCompany}`,
          vesselPublicKey,
          vesselSecretKey
        ),
        vesselStakeholderInsuranceRef: encrypt(
          vessel?.vesselStakeholderInsuranceRef,
          vesselPublicKey,
          vesselSecretKey
        ),
        vesselStakeholderMYBA: encrypt(
          vessel?.vesselStakeholderMYBA,
          vesselPublicKey,
          vesselSecretKey
        ),
        vesselStakeholderVAT: encrypt(
          vessel?.vesselStakeholderVAT,
          vesselPublicKey,
          vesselSecretKey
        ),
        vesselStakeholderFinancialGuarantee: encrypt(
          vessel?.vesselStakeholderFinancialGuarantee,
          vesselPublicKey,
          vesselSecretKey
        ),
        vesselSpecialConditions: encrypt(
          vessel?.vesselSpecialConditions,
          vesselPublicKey,
          vesselSecretKey
        ),
      };
      const response = await vesselServices?.transfer(
        vesselId,
        userId,
        email,
        keys,
        cryptedData
      );
      const vessels = await vesselServices?.getVesselsByAuthor(userId);
      setVessels(vessels);
      setIsLoading(false);
      toggle();
      dispatch(alertActions.setAlert(t(response), alertConstants.SUCCESS));
            }
    
    } catch (error) {
      setIsLoading(false);
      dispatch(alertActions.setAlert(t(error), alertConstants.ERROR));
    }
  };

  return (
    <>
      <Modal show={show} onHide={toggle}>
        <Modal.Header closeButton>
          <Modal.Title className={classes.modalTitle}>
            {t("Transfer vessel")}
            <br />
            {decrypt(sheetName, publicKey, secretKey)}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Control
            type="email"
            value={email}
            onChange={handleChange}
            placeholder="Enter user's email"
            required
          />
        </Modal.Body>
        <Modal.Footer>
          {" "}
          <Button onClick={handleTransfer} disabled={isLoading}>
            {t("Transfer")}
          </Button>
          <Button onClick={toggle}>{t("Cancel")}</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
